<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0">Su perfil personal</h3>
    <hr>

    <div class="row">
      <div class="col-sm-4">
        <p> <b>Nombres:</b> {{parseUs()}} </p>
        <p class="text-primary"> <b>Cargos de usuario:</b> </p>
        <div v-bind:key="ind" v-for="(c,ind) in usuario.cargos">
          <p> <b>{{c.sede.nombre}}</b> {{c.cargo.nombre}} </p>
        </div>
      </div>
      <div class="col-sm-4">
        <Datos />
      </div>
        <div class="col-sm-4">
        <div class="container-fluid">
          <img :src="img_logo" class="img-responsive">
        </div>
      </div>
    </div>
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import Datos from '@/components/AClave.vue'
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      img_logo: process.env.VUE_APP_LOGO,
      usuario:{
        cargos: [],
      }
    }
  },
  components:{Datos},
  methods:{
    parseUs(){
      if( this.usuario.seg_apellido == null ) this.usuario.seg_apellido = '';
      return this.usuario.nombres+' '+this.usuario.pri_apellido+' '+this.usuario.seg_apellido; 
    },
    getDatos(){
      //var vue = this;
      var sql = gql`query{getUsuario(id:${this.usuario.id}){ id,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{nombre},sede{nombre}}}}`
      // window.console.log( sql )

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        this.usuario = data.data.getUsuario.datos_personales;
        this.usuario.cargos = data.data.getUsuario.cargos;

      }).catch((error) => {
        //vue.$refs.alertar.invalido();
        window.console.error(window.stringifyObject(error));
        this.$notify( parseJsonError( error,'getUsuario' ) )
      })
    },
  },
  mounted(){
    this.usuario = this.$store.state.DATA_USER;
    this.getDatos();
  }
}
</script>